module.exports = __webpack_public_path__ + "static/media/marketoProcess2.59776a1d.png";